import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import {
  NonNullableFormBuilder,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { nullThrows } from '@thred/shared-common';
import { MatButtonModule } from '@angular/material/button';

export type NumberInputDialogData = {
  number: null | number;
  title: string;
  label: string;
  placeholder: string;
};
export type NumberInputDialogResult = { number: number };

@Component({
  selector: 'thred-number-input-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatInputModule,
    ReactiveFormsModule,
    MatButtonModule,
  ],
  templateUrl: './number-input-dialog.component.html',
  styleUrls: ['./number-input-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NumberInputDialogComponent {
  fg = this.fb.group({
    number: [this.data.number, Validators.required],
  });

  constructor(
    private fb: NonNullableFormBuilder,
    @Inject(MAT_DIALOG_DATA)
    public data: NumberInputDialogData,
    private ref: MatDialogRef<
      NumberInputDialogComponent,
      NumberInputDialogResult
    >,
  ) {}
  submitForm() {
    if (!this.fg.valid) {
      return;
    }
    const v = this.fg.getRawValue();
    this.ref.close({ number: nullThrows(v.number) });
  }
}
